import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-tools-line',
    label: 'Excavation',
    desc: 'Residential and commercial foundation prep, drainage, utility trenching, pond construction, and more.',
    path: '/services',
  },
  {
    icon: 'ri-road-map-line',
    label: 'Grading',
    desc: 'Rough and finish grading for driveways, building pads, parking areas, and drainage.',
    path: '/services',
  },
  {
    icon: 'ri-home-gear-line',
    label: 'Property Maintenance',
    desc: 'Ongoing landscaping, lawn care, and general property maintenance to keep your land looking its best year-round.',
    path: '/services',
  },
  {
    icon: 'ri-plant-line',
    label: 'Forestry Mulching',
    desc: 'Trees and brush ground into mulch on-site. No burning or hauling. Reduces erosion.',
    path: '/services',
  },
  {
    icon: 'ri-scissors-cut-line',
    label: 'Land Clearing',
    desc: 'Residential lots, commercial parcels, acreage, overgrown fence lines, and neglected land cleared for development, agriculture, or general use.',
    path: '/services',
  },
  {
    icon: 'ri-building-line',
    label: 'Site Development',
    desc: 'Full site prep from raw land to build-ready. Clearing, grading, drainage, and access roads.',
    path: '/services',
  },
  {
    icon: 'ri-hammer-line',
    label: 'Demolition',
    desc: 'Residential and commercial structures, foundations, concrete, full site cleanup.',
    path: '/services',
  },
  {
    icon: 'ri-leaf-line',
    label: 'Food Plot Development',
    desc: 'Clearing, grading, and soil preparation for hunting and wildlife management plots.',
    path: '/services',
  },
];

export default function ServicesGrid() {
  return (
    <section className="w-full bg-brand-charcoal py-24 px-6 lg:px-12">
      <div className="w-full max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="font-heading text-brand-green-accent text-xs tracking-[0.4em] uppercase mb-3">What We Do</p>
          <h2 className="font-heading font-800 text-white text-5xl md:text-6xl tracking-widest uppercase mb-4">
            Our Services
          </h2>
          <div className="w-12 h-0.5 bg-brand-green-accent mx-auto" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-brand-charcoal-mid">
          {services.map((svc) => (
            <Link
              to={svc.path}
              key={svc.label}
              className="bg-brand-charcoal hover:bg-brand-charcoal-light group p-8 flex flex-col gap-4 cursor-pointer transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center border border-brand-green-mid group-hover:border-brand-green-accent group-hover:bg-brand-green/20 transition-colors rounded-sm">
                <i className={`${svc.icon} text-brand-green-accent text-xl`} />
              </div>
              <h3 className="font-heading font-700 text-white text-xl tracking-wider uppercase">
                {svc.label}
              </h3>
              <p className="font-body text-sm text-gray-400 leading-relaxed">
                {svc.desc}
              </p>
              <div className="flex items-center gap-2 mt-auto pt-2">
                <span className="font-heading text-xs tracking-widest uppercase text-brand-green-accent">Learn More</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-brand-green-accent text-xs" />
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <Link
            to="/contact"
            className="inline-block px-10 py-4 bg-brand-green hover:bg-brand-green-mid font-heading font-700 text-white text-lg tracking-widest uppercase cursor-pointer whitespace-nowrap transition-colors rounded-sm"
          >
            Get a Quote
          </Link>
        </div>
      </div>
    </section>
  );
}
